import React from 'react'

export const OngoingSeeMore = () => {
   return (
      <div className="calc_minHeight container  mt-4">
         On-Going See More
      </div>
   )
}
